var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          staticClass: "right",
          attrs: { variant: "primary" },
          on: {
            click: function ($event) {
              _vm.isModalOpen = true
            },
          },
        },
        [_vm._v("\n        Dateien hinzufügen\n    ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { "hide-footer": "", size: "lg", title: "Dateien hochladen" },
          on: {
            hide: function ($event) {
              return _vm.reset()
            },
          },
          model: {
            value: _vm.isModalOpen,
            callback: function ($$v) {
              _vm.isModalOpen = $$v
            },
            expression: "isModalOpen",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "record-document-upload-modal loading-content-container",
            },
            [
              _vm.queueIsProcessing
                ? _c(
                    "div",
                    {
                      staticClass:
                        "loading-overlay d-flex justify-content-center pt-5",
                    },
                    [_c("csp-loading-indicator")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-inline form-inline-stacked" },
                [
                  _c("csp-form-group-select-searchable", {
                    ref: "categoryGroupSelect",
                    staticClass: "col-4",
                    attrs: {
                      form: _vm.fileUploadForm,
                      "options-loader": _vm.loadFileCategoryGroupOptions,
                      "override-label": "Zuordnung",
                      property: "categoryGroupId",
                      type: "autocomplete",
                    },
                    on: {
                      changeOption: function ($event) {
                        _vm.selectedCategoryGroup = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-form-group-select-searchable", {
                    ref: "categorySelect",
                    staticClass: "col-4",
                    attrs: {
                      "auto-select-single-option": true,
                      dependencies: ["categoryGroupId"],
                      form: _vm.fileUploadForm,
                      "options-loader": _vm.loadFileCategoryOptions,
                      "override-label": "Kategorie",
                      property: "categoryId",
                      type: "autocomplete",
                    },
                    on: {
                      changeOption: function ($event) {
                        return _vm.onCategorySelected($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-hide-for-group", {
                    staticClass: "col-4",
                    attrs: {
                      "damage-record-note-id": _vm.damageRecordNoteId,
                      form: _vm.fileUploadForm,
                      "is-loading-from-parent": _vm.isLoadingHideSettings > 0,
                      "mandatory-hide-for-group": _vm.mandatoryHideForGroup,
                      property: "hideForGroup",
                      "record-id": _vm.recordId,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "csp-base-file-upload",
                {
                  ref: "fileUpload",
                  staticClass: "multi-file-upload",
                  attrs: {
                    "auto-process-queue": false,
                    "before-file-added": _vm.validateUploadPreconditions,
                    "block-upload": !_vm.categorySelected,
                    "file-input-name": "fileUpload",
                    "multiple-upload": true,
                    title: _vm.$t("record document upload"),
                    "upload-error-message": _vm.$t(
                      "record document upload error"
                    ),
                    "upload-url": _vm.uploadUrl,
                  },
                  on: {
                    "after-files-added": _vm.handleAfterFilesAdded,
                    "before-upload": _vm.handleBeforeUpload,
                    "file-added": _vm.handleFileAdded,
                    "file-removed": _vm.handleFileRemoved,
                    "file-upload-complete": _vm.handleFileUploadComplete,
                    "file-upload-progress": _vm.handleFileUpdate,
                    "total-upload-progress": _vm.handleTotalUploadProgress,
                    "upload-complete": _vm.handleUploadComplete,
                    "upload-disabled": _vm.handleUploadDisabled,
                  },
                },
                [_vm._t("default")],
                2
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "w-100 my-2",
                  attrs: {
                    disabled: _vm.filesForUpload.length === 0,
                    size: "sm",
                    variant: "primary",
                  },
                  on: { click: _vm.processQueue },
                },
                [_vm._v("\n                Dateien hochladen\n            ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "file-preview-container mt-2" },
                [
                  _vm.filesForUpload.length > 0
                    ? _c("b-table", {
                        attrs: {
                          fields: _vm.previewTableFields,
                          items: _vm.filesForUpload,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "table-colgroup",
                              fn: function (scope) {
                                return _vm._l(scope.fields, function (field) {
                                  return _c("col", {
                                    key: field.key,
                                    style: { width: field.width ?? "auto" },
                                  })
                                })
                              },
                            },
                            {
                              key: "cell(actions)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-actions",
                                      staticStyle: { "text-align": "right" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "file-remove",
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeFile(
                                                data.item.file
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "inticon-remove",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          910489463
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.queueIsProcessing
                ? _c(
                    "div",
                    { staticClass: "upload-progress my-3" },
                    [
                      _c("b-progress", {
                        attrs: {
                          max: "100",
                          "show-progress": "",
                          value: _vm.totalUploadProgress,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }